export enum StatusType {
    Pending = 'Pending',
    InProgress = 'In Progress',
    NotFound = 'Not Found',
    Expired = 'Expired',
    Submitted = 'Submitted',
}
